import React from "react";
import { Pagination as AntDPagination } from "antd";
import { MappedSizeDefault } from "@type/sizing";
import { PaginationProps } from "./pagination.types";

export const Pagination = ({ size = "medium", ...rest }: PaginationProps) => {
    return (
        <AntDPagination
            size={MappedSizeDefault[size]}
            {...rest}
        ></AntDPagination>
    );
};

Pagination.displayName = "Pagination";
